import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=df0a0f20&scoped=true&"
var script = {}
import style0 from "./Avatar.vue?vue&type=style&index=0&id=df0a0f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0a0f20",
  null
  
)

export default component.exports